export enum SortPriceType {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
}
